import TwentyFourHourIcon from 'assets/images/psp/twentyfour-hour.svg';
import Camera from 'assets/images/psp/camera.svg';
import Garage from 'assets/images/psp/garage.svg';
import MeasureYourTruck from 'assets/images/psp/Truck/measure-your-truck.webp';
import truckBoatCarContentSectionSVG from 'assets/images/content-section/Illustration-Truck-Boat-Car.svg';
import TruckHero from 'assets/images/psp/hero/truck-hero.webp';
import Featured1 from 'assets/images/psp/FeaturedImages/truckFeatured1.webp';
import Featured2 from 'assets/images/psp/FeaturedImages/rv4.webp';
import Featured3 from 'assets/images/psp/FeaturedImages/truckFeatured3.webp';
import Featured4 from 'assets/images/psp/FeaturedImages/car4.webp';

const pickUpTruckContent =
	'### Pickup Truck Storage\n\n' +
	'- **Compact Pickup (Toyota Tacoma, Ford Ranger):** 15–20 ft parking space\n\n' +
	'- **Full-Size Pickup (Ford F-150, Chevy Silverado):** 20–25 ft parking space\n\n' +
	'- **Heavy-Duty Pickup (Ford F-250, Ram 2500):** 25–30 ft parking space\n\n' +
	'### Commercial Truck Storage\n\n' +
	'- **Food Truck Storage:** 25–35 ft parking space (varies by truck size and equipment)\n\n' +
	'- **Box Truck Storage:** 20–30 ft parking space\n\n' +
	'- **Semi Truck Storage:** 50–80 ft parking space with additional maneuvering room';

const truckStorageCostContent =
	'### Pickup Truck Storage\n\n' +
	'- **Outdoor Uncovered:** $50–$150 per month\n\n' +
	'- **Outdoor Covered:** $80–$200 per month\n\n' +
	'- **Indoor Storage Unit:** $150–$400 per month\n\n\n' +
	'### Food Truck Storage\n\n' +
	'- **Outdoor with Electrical:** $100–$300 per month\n\n' +
	'- **Covered with Utilities:** $200–$500 per month\n\n' +
	'- **Full-Service Storage:** $300–$800 per month\n\n\n' +
	'### Semi Truck Storage\n\n' +
	'- **Outdoor Parking:** $150–$400 per month\n\n' +
	'- **Covered Storage:** $300–$700 per month\n\n' +
	'- **Secure Facility:** $400–$1,000+ per month\n\n\n' +
	'### Factors Affecting Cost:\n\n' +
	'- Geographic location (highly populated or urban areas typically cost more, as demand is higher)\n\n' +
	'- Security features and facility amenities\n\n' +
	'- Length of storage commitment (annual contracts often offer discounts)\n\n' +
	'- Additional services (washing, maintenance, electrical hookups)';

const truckStoragePrepContent =
	"Getting your truck ready for storage isn't just about parking it and walking away. Here's [how to prep your truck for both short-term and long-term storage](https://www.sparefoot.com/blog/dont-skip-these-7-tips-for-long-term-car-storage):\n\n" +
	'### Essential Preparation Steps \n\n' +
	'#### Clean Inside and Out \n\n' +
	'Give your truck a thorough cleaning before storage. Remove all personal items, food, and anything that could attract pests or create odors. A clean truck is a happy truck in storage.\n\n\n' +
	'#### Check and Top Off Fluids \n\n' +
	"Change the oil if you're storing long-term, top off the gas tank, and add fuel stabilizer. Check brake fluid, coolant, and other essential fluids. For food trucks, ensure all kitchen equipment is properly cleaned and disconnected.\n\n\n" +
	'#### Battery Care \n\n' +
	'For storage longer than 30 days, consider disconnecting the battery or using a battery tender. This prevents draining and extends battery life.\n\n\n' +
	'#### Tire Preparation \n\n' +
	'Inflate tires to the recommended pressure and consider moving the truck periodically to prevent flat spots. For long-term storage, tire covers can prevent cracking.\n\n\n' +
	'#### Protect the Interior \n\n' +
	'Use sunshades or covers to protect the interior from UV damage. Leave windows slightly cracked for ventilation if storing in a covered area.';

const reviews = [
	{
		reviewTitle:
			'The SpareFoot representative on the phone was very patient.',
		link: 'https://www.trustpilot.com/reviews/647cd361c42344628670187f',
		reviewRating: 5,
		reviewText:
			'The SpareFoot representative that I spoke with on the phone was very patient and did his very best to find a storage space that was fitting for my food truck.',
		reviewerName: 'Marcie Rowe',
		reviewerInitials: 'MR',

		reviewDate: '',
	},
	{
		reviewTitle: 'The SpareFoot customer service representative helped me.',
		link: 'https://www.trustpilot.com/reviews/6458135d746ca7dfea1865de',
		reviewRating: 5,
		reviewText:
			'The SpareFoot customer service representative who helped me was wonderful and found a place that was very close to my existing apartment. I told him that I was looking for a climate-controlled storage unit and a free rental truck. He found exactly what I needed.',
		reviewerName: 'Michelle',
		reviewerInitials: 'M',

		reviewDate: '',
	},
	{
		reviewTitle: 'The SpareFoot representative I dealt with was amazing.',
		link: 'https://www.trustpilot.com/reviews/61af94e50b7cbbcbfe042ceb',
		reviewRating: 5,
		reviewText:
			'The person I dealt with was amazing. I needed storage for a Diesel sleeper truck that I purchased from an auction in MD. He found me a place, even called them to verify I would have no problems storing my vehicle.',
		reviewerName: 'Pamela Mathews',
		reviewerInitials: 'PM',

		reviewDate: '',
	},
	{
		reviewTitle: 'SpareFoot representative was extremely helpful…',
		link: 'https://www.trustpilot.com/reviews/5e5ffdb63c93ae0bc40fef48',
		reviewRating: 5,
		reviewText:
			'Marcia from SpareFoot was extremely helpful and went above and beyond to help find and book parking for our truck and trailer.',
		reviewerName: 'Ricky Lail',
		reviewerInitials: 'RL',

		reviewDate: '',
	},
];

const truckStorageFAQs = [
	{
		question: 'How much does truck storage cost per month?',
		answer:
			'Truck storage costs vary significantly based on your truck type, location, and storage preferences. For pickup truck storage, expect to pay between $50-$400 per month. Outdoor uncovered spaces for pickup trucks typically run $50-$150 monthly, while covered outdoor storage ranges from $80-$200 per month. Indoor storage units for trucks can cost $150-$400 monthly, depending on size and amenities.\n\n' +
			'Food truck storage near me searches typically reveal costs between $100-$800 per month, with basic outdoor parking starting around $100-$300 and full-service storage with utilities and commissary access reaching $300-$800. Storage for semi trucks ranges from $150-$1,000+ monthly, with outdoor parking being the most affordable option and secure facilities with additional services commanding premium prices.\n\n' +
			'Geographic location plays a major role in pricing, with urban areas and coastal regions typically charging more than rural locations. Seasonal demand also affects costs, particularly in areas with harsh winters where indoor storage becomes more valuable. Many facilities offer discounts for long-term commitments, annual contracts, or bundled services like car and truck storage packages.',
	},
	{
		question: 'Can I store my pickup truck in a regular storage unit?',
		answer:
			"Yes, you can store pickup trucks in storage units, but you'll need to ensure the unit is large enough and has the right features. Most compact pickup trucks can fit in a 10x30 storage unit, while full-size pickups typically require a 12x40 or larger unit. The key considerations are length, width, and height – make sure to measure your truck, including mirrors, bed covers, and any accessories.\n\n" +
			'Look for storage units with drive-up access and wide doors to make entry and exit easier. Some facilities offer specialized pickup truck storage solutions with higher ceilings and wider units designed specifically for vehicles. Climate-controlled units provide additional protection for classic trucks or vehicles with sensitive electronics, though they come at a higher cost.\n\n' +
			"Before choosing indoor storage, verify the facility's policies regarding vehicle storage. Some storage facilities require proof of registration, insurance, and may have restrictions on fuel levels or battery maintenance. Indoor storage works particularly well for seasonal vehicle storage, classic truck protection, or when you need to store work equipment alongside your pickup truck.",
	},
	{
		question:
			"What's the difference between storage units with free truck rental and truck storage?",
		answer:
			'This is a common confusion point. Storage units with free truck rental refer to facilities that provide moving trucks as part of their rental package – essentially, you get a U-Haul-style truck to help you move your belongings into storage. This service is typically offered when you rent a traditional storage unit for household goods.\n\n' +
			"Truck storage, on the other hand, is when you're storing your own truck at a facility. This includes pickup truck storage, food truck storage, semi truck storage, or any situation where your vehicle is what's being stored, not what's helping you move items into storage.\n\n" +
			"Some facilities offer both services – self-storage and truck rental for moving, plus vehicle storage options for your trucks. When searching for storage pickup truck solutions, make sure you're looking at facilities that offer vehicle parking rather than just moving truck rentals. The pricing, space requirements, and facility features are completely different between these two services.",
	},
	{
		question:
			'How do I find food truck storage near me with kitchen prep access?',
		answer:
			'Finding food truck storage with commissary or kitchen prep access requires looking for specialized facilities that understand the unique needs of food truck operators. Start by searching for "food truck storage near me" and look for facilities that specifically mention food service storage or commissary access. Many cities have dedicated food truck storage facilities that offer electrical hookups, water access, and shared prep spaces.\n\n' +
			'Check with local restaurant supply stores, culinary schools, or food truck associations – they often have connections with storage facilities that cater to food service businesses. Some commercial kitchens offer food truck storage as part of their commissary services, providing both parking and licensed kitchen space for prep work.\n\n' +
			'When evaluating facilities, ask about electrical hookups (many food trucks need power for refrigeration), water access for cleaning, waste disposal options, and any health department requirements. Some facilities also offer additional services like truck washing, maintenance, and even permit assistance for food truck operators.',
	},
	{
		question: 'What should I look for in storage for semi trucks?',
		answer:
			"Semi truck storage requires specialized facilities with specific features that regular vehicle storage can't provide. Look for storage facilities with extra-wide access roads and parking spaces that can accommodate an 80-foot truck and trailer combination. The facility should have reinforced pavement capable of supporting heavy vehicle weights – standard parking lots aren't designed for loaded semi trucks.\n\n" +
			'Security is crucial for semi-truck storage, as these vehicles and their cargo represent significant value. Look for facilities with 24/7 security monitoring, gated access, adequate lighting, and preferably security cameras throughout the property. Some facilities offer additional security services like driver check-in procedures and cargo monitoring.\n\n' +
			'Consider facilities that offer truck-specific amenities like wash bays, maintenance areas, electrical hookups for refrigerated trailers, and fuel services. Location is also important – choose storage that provides easy access to major highways without requiring navigation through residential areas or roads with weight restrictions. Many professional drivers prefer facilities that offer both truck and trailer storage options, allowing them to unhook trailers when needed.',
	},
	{
		question: 'Are there pickup truck storage ideas for small properties?',
		answer:
			"If you're working with limited space but still need pickup truck storage solutions, there are several creative approaches to consider. Vertical storage solutions like car lifts can work for smaller pickup trucks, allowing you to store two vehicles in the space of one. However, this requires significant upfront investment and proper installation.\n\n" +
			'Shared storage arrangements with neighbors or friends can be cost-effective – consider splitting the cost of a larger storage unit or outdoor parking space. Some homeowners with large properties rent out parking spaces specifically for pickup truck storage, which can be more affordable than commercial facilities.\n\n' +
			'For temporary storage needs, consider seasonal arrangements where you store your truck during months when you use it less frequently. This can be more cost-effective than year-round storage. Some storage facilities offer short-term pickup truck storage options for people who need space during home renovations, moves, or extended travel.\n\n' +
			'Modular storage solutions like portable buildings or carports can be installed on your property if local zoning allows. These pickup truck storage ideas provide weather protection while keeping your vehicle accessible and can often be moved if you relocate.',
	},
];

export const TruckContent = {
	type: 'Truck',
	sections: [
		{
			title: 'Truck Storage Hero',
			background: 'yellow',
			modules: [
				{
					type: 'hero',
					background: 'lighterYellow',
					props: {
						content: {
							title: 'Find the Best Truck Storage For You',
							description:
								'Let’s face it. Trucks are getting bigger, and the extra space near your home and job is getting smaller. Truck storage is the answer to the burning questions you have, like, “Where should I park my truck?” and “Can I put my truck in a storage unit?” \n\n SpareFoot connects you with storage facilities that will roll out the red carpet for trucks. From Ford F-150 storage to outdoor truck storage for Mack trucks and oversized vehicles, we’ve got you covered. \n\n All you have to do is use our quick and easy storage search tool to find the right size truck storage solution, with the option to filter for extra amenities like climate control, 24/7 access, and deals like [free truck rentals](https://www.sparefoot.com/blog/moving-truck-rental-cost).',
							image: TruckHero,
							CTAText: 'Search Truck Storage Now',
						},
					},
				},
			],
		},
		{
			title: 'nearby storage',
			background: 'gray',
			noPaddingBottom: true,
			modules: [
				{
					type: 'facilitiesNearYou',
					props: {
						title: 'Popular Truck Storage Facilities Near',
					},
				},
			],
		},
		{
			title: 'What Kind of Truck Storage Do You Need?',
			modules: [
				{
					type: 'content',
					props: {
						title: 'What Kind of Truck Storage Do You Need?',
						contentType: 'row-type',
						ShowBackgroundImage: false,
						content: [
							"Not all trucks are created equal, and neither are their storage needs. Whether you're looking for pickup truck storage, food truck storage, or storage for semi trucks, the [right solution depends on your specific situation](https://www.sparefoot.com/blog/how-to-find-the-right-storage-facility-for-your-car-rv-or-boat). \n\nHere's how different truck storage options stack up:",
						],
					},
				},
				{
					type: 'sizeChart',
					props: {
						slug: 'truck-storage-size-chart',
						columnWidths: [1, 2, 3, 2],
						headers: [
							{
								label: 'Storage Type',
								key: 'Storage Type',
							},
							{
								label: 'What is it?',
								key: 'What is it?',
							},
							{
								label: 'Benefits',
								key: 'Benefits',
							},
							{
								label: 'Cost Comparison',
								key: 'Cost Comparison',
							},
						],
						rows: [
							{
								'Storage Type': 'Outdoor Truck Storage',
								'What is it?':
									'Large parking spaces specifically designed for trucks and oversized vehicles. Some facilities offer covered outdoor truck storage for weather protection.',
								Benefits:
									'Perfect for pickup truck storage and larger vehicles. Easy access for daily use, no height restrictions, and often includes amenities like wash stations. Great for contractors who need frequent access to their work trucks.',
								'Cost Comparison':
									'Most affordable truck storage option.',
							},
							{
								'Storage Type': 'Indoor Truck Storage',
								'What is it?':
									'Climate-controlled storage units or warehouse-style facilities that can accommodate trucks under certain height limits.',
								Benefits:
									'Ideal for classic trucks, food trucks with sensitive equipment, or vehicles stored long-term. Provides maximum protection from weather, theft, and vandalism. Often includes additional services like maintenance and detailing.',
								'Cost Comparison':
									'Mid to high-range pricing, varying by amenities and location.',
							},
							{
								'Storage Type': 'Covered Truck Storage',
								'What is it?':
									'Outdoor parking with overhead protection from a roof or canopy structure.',
								Benefits:
									'Balances cost and protection. Keeps trucks dry and protected from sun damage while maintaining easy access. A popular choice for pickup truck storage solutions.',
								'Cost Comparison':
									'Moderate pricing between outdoor and indoor options.',
							},
						],
					},
				},
			],
		},
		{
			title: 'Truck Storage Content',
			background: 'yellow',
			modules: [
				{
					type: 'content',
					props: {
						title: 'Truck Storage Size Guide & Comparisons',
						contentType: 'row-type',
						ShowBackgroundImage: true,
						contentImage: MeasureYourTruck,
						content: [
							"Figuring out [what size storage space you need for your truck](https://www.sparefoot.com/blog/car-storage-size-guide) doesn't have to be complicated. Here's your guide to matching your truck with the right storage solution.\n\n" +
								'### How to Measure Your Truck for Storage\n\n' +
								'Before searching for storage, grab a tape measure and get these key dimensions:\n\n',
						],
					},
				},
			],
		},
		{
			title: 'Outdoor Truck Storage Sizing',
			background: 'gray',
			modules: [
				{
					type: 'content',
					props: {
						title: 'Outdoor Truck Storage Sizing',
						contentType: 'row-type',
						ShowBackgroundImage: true,
						content: [
							"For outdoor truck storage, facilities typically offer designated parking spaces rather than enclosed units. Most outdoor storage lots can accommodate oversized trucks and trailers that won't fit in traditional storage units, making them ideal for food trucks, work trucks with equipment, or semi trucks that need flexible space. \n\n The main advantage is that outdoor storage eliminates height restrictions and door clearance issues, allowing you to store trucks with ladder racks, light bars, or other tall accessories without modification. \n\n" +
								pickUpTruckContent,
						],
					},
				},
			],
		},
		{
			title: 'Indoor Truck Storage Unit Size Guide',
			modules: [
				{
					type: 'content',
					props: {
						title: 'Indoor Truck Storage Unit Size Guide',
						contentType: 'row-type',
						ShowBackgroundImage: false,
						content: [
							"Once you’ve measured your truck's height, width, and length, you’re on your way to finding the right size storage unit for your truck. If you’ve got a pickup truck or a mid-size vehicle, indoor truck parking will provide you premium protection in storage. \n\n" +
								"When you need enclosed storage, here's how common unit sizes match up with different trucks:\n\n",
						],
					},
				},
				{
					type: 'sizeChart',
					props: {
						headers: [
							{
								label: 'Unit Size',
								key: 'Unit Size',
							},
							{
								label: 'Dimensions',
								key: 'Dimensions',
							},
							{
								label: 'What Fits',
								key: 'What Fits',
							},
							{
								label: 'Best For',
								key: 'Best For',
							},
						],
						rows: [
							{
								'Unit Size': {
									type: 'markdown',
									markdown: '**10x20**',
								},
								Dimensions: "10' W x 20' L x 8' H",
								'What Fits': 'Compact pickup trucks only',
								'Best For':
									'Short-bed compact trucks, seasonal storage',
							},
							{
								'Unit Size': {
									type: 'markdown',
									markdown: '**10x30**',
								},
								Dimensions: "10' W x 30' L x 8' H",
								'What Fits':
									'Most compact pickups, some mid-size',
								'Best For': 'Standard pickup truck storage',
							},
							{
								'Unit Size': {
									type: 'markdown',
									markdown: '**12x30**',
								},
								Dimensions: "12' W x 30' L x 8–10' H",
								'What Fits': 'Full-size pickups (tight fit)',
								'Best For':
									'Single-cab or short-bed full-size trucks',
							},
							{
								'Unit Size': {
									type: 'markdown',
									markdown: '**12x40**',
								},
								Dimensions: "12' W x 40' L x 8–10' H",
								'What Fits': 'Full-size pickups comfortably',
								'Best For':
									'Most popular size for pickup truck storage',
							},
							{
								'Unit Size': {
									type: 'markdown',
									markdown: '**15x40**',
								},
								Dimensions: "15' W x 40' L x 10–12' H",
								'What Fits':
									'Full-size trucks with room to spare',
								'Best For':
									'Trucks with accessories, work equipment storage',
							},
							{
								'Unit Size': {
									type: 'markdown',
									markdown: '**20x40**',
								},
								Dimensions: "20' W x 40' L x 10–14' H",
								'What Fits':
									'Food trucks, box trucks, and large pickups',
								'Best For':
									'Commercial vehicles, multiple vehicle storage',
							},
							{
								'Unit Size': {
									type: 'markdown',
									markdown: '**20x50**',
								},
								Dimensions: "20' W x 50' L x 12–14' H",
								'What Fits': 'Large commercial vehicles',
								'Best For':
									'Food trucks with equipment, small RVs',
							},
						],
					},
				},
			],
		},
		{
			title: 'Why Choose Truck Storage Over Street Parking?',
			background: 'gray',
			noPaddingBottom: true,
			modules: [
				{
					type: 'content',
					props: {
						title: 'Why Choose Truck Storage Over Street Parking?',
						contentType: 'row-type',
						ShowBackgroundImage: false,
						content: [
							"Parking your truck at home isn't always realistic. Your neighbors are giving you looks, your HOA is sending passive-aggressive letters, and your driveway situation is becoming a topic of family debate. Sound familiar? Here's why dedicated truck storage beats the home parking struggle:",
						],
					},
				},
				{
					type: 'unitList',
					props: {
						unitsData: [
							{
								image: Camera,
								content:
									'### Advanced Protection\n\n' +
									'Street parking leaves your truck vulnerable to weather, theft, and that one neighbor who somehow always manages to ding your door. Truck storage facilities offer security, weather protection, and peace of mind.',
							},
							{
								image: Garage,
								content:
									'### More Space Than An Extended Cab\n\n' +
									'No more measuring driveways or playing truck Tetris in your garage. Storage facilities are designed for vehicles like yours, with proper spacing and access.',
							},
							{
								image: TwentyFourHourIcon,
								content:
									'### Your Truck, Your Schedule\n\n' +
									'Unlike street parking restrictions, truck storage gives you 24/7 access to your vehicle when you need it most.',
							},
						],
					},
				},
			],
		},
		{
			title: 'Storage Type Average Costs (2025)',
			background: 'yellow',
			modules: [
				{
					type: 'content',
					props: {
						title: 'Storage Type Average Costs (2025)',
						contentType: 'row-type',
						ShowBackgroundImage: true,
						content: [
							"Truck storage costs vary based on location, truck size, and storage type. Here's what you can expect to pay in 2025:\n\n" +
								truckStorageCostContent,
						],
					},
				},
			],
		},

		{
			title: 'How to Prepare Your Truck for Storage',
			modules: [
				{
					type: 'content',
					props: {
						title: 'How to Prepare Your Truck for Storage',
						contentType: 'row-type',
						ShowBackgroundImage: true,
						contentImage: truckBoatCarContentSectionSVG,
						content: [truckStoragePrepContent],
					},
				},
			],
		},
		{
			title: 'Reviews Section',
			background: 'dark',
			modules: [
				{
					type: 'reviews',
					props: {
						reviews,
						title: '50,000+ Storage Users Choose SpareFoot for Truck Storage & More',
					},
				},
			],
		},
		{
			title: 'FAQ Section',
			modules: [
				{
					type: 'faqs',
					props: {
						header: 'Truck Storage FAQs',
						faqs: truckStorageFAQs,
					},
				},
			],
		},
		{
			title: 'Related Content Section',
			background: 'gray',
			modules: [
				{
					type: 'featuredContent',
					props: {
						slug: 'truck-storage-related-content',
						contentCards: [
							{
								content:
									'Moving Truck Rental Cost: Pricing Factors + Best Options in 2025',
								date: 'January 15, 2025',
								title: 'Moving Tips',
								image: Featured1,
								link: 'https://sparefoot.com/blog/moving-truck-rental-cost',
							},
							{
								content: 'RV Storage Size Guide',
								date: 'October 20, 2025',
								image: Featured2,
								title: 'How to Store It',
								link: 'https://sparefoot.com/blog/rv-storage-size-guide',
							},
							{
								content:
									'How to Pick the Right Size Storage Unit for Your Car',
								title: 'How to Store It',
								image: Featured3,
								link: 'https://sparefoot.com/blog/car-storage-size-guide',
								date: 'October 20, 2025',
							},
							{
								content:
									'Proper Storage Tips for Vehicle Batteries',
								date: 'September 26, 2025',
								link: 'https://sparefoot.com/blog/proper-storage-tips-for-vehicle-batteries',
								image: Featured4,
								title: 'General Storage Advice',
							},
						],
					},
				},
			],
		},
		{
			title: 'Link to other PSPs',
			background: 'yellow',
			modules: [
				{
					type: 'links',
					props: {
						title: 'More Ways to Store',
						cards: [
							'Vehicle',
							'DriveUp',
							'Car',
							'Boat',
							'RV',
							'JetSki',
							'ATV',
							'Electricity',
						],
					},
				},
			],
		},
		{
			title: 'nearby units',
			modules: [
				{
					type: 'storageNearYou',
				},
			],
		},
	],
};
